export default function (str) { return str !== ''; };

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/Ractive/prototype/shared/notEmptyString.js.map
